$(function() {
    var $configurator = $('#simple-configurator');
    if (!$configurator.length) return;
    $('.load').addClass('hidden');
    var $total = $configurator.find('[data-price=total]');
    var $totalForRegularCustomer = $configurator.find('[data-price=total-regular-price]');
    var $totalWithoutTax = $configurator.find('[data-price=totalWithoutTax]');
    var $item = $configurator.find('[data-price=item]');
    var $discountValue = $configurator.find('[data-price=discountValue]');
    var $discount = $configurator.find('[data-price=discount]');
    var $ordinary = $configurator.find('[data-price=ordinary]');
    var $regularDiscount = $configurator.find('[data-price=regular-discount]');
    var $regularOrdinary = $configurator.find('[data-price=regular-ordinary]');
    var $quantity = $configurator.find('.quantity-input');
    var product = $configurator.attr('data-product');
    var config = $configurator.attr('data-configuration');
    var edit = $configurator.attr('data-edit');
    var $hingeSelect = $configurator.find('select.hinge');
    var $sizeSelect = $configurator.find('select.size');
    var $widthSelect = $configurator.find('select.width');
    var $heightSelect = $configurator.find('select.height');
    var $selectParameters = $configurator.find('.select-parameters');
    var $priceUnit = $configurator.find('.price-unit');
    var $buyButton = $('.simple-product__buy-button');
    var $accessoriesList = $('#simpleConfiguratorAccessories');
    var $accessoriesResetButton = $accessoriesList.find('.subProductItem__header-reset-btn');
    var initialSubProductsSelected = [];
    var configData = {};
    var getPrice = false;
    var price = 0;
    var regularCustomerPrice = 0;
    var netPrice = 0;
    var discount = 0;
    var discountValueForRegularCustomer = 0;
    var netDiscount = 0;
    var discountValue = 0;
    var locks = {
        stock: false,
        subProducts: false,
    };
    let assocProductSwitch = $('.product-associated-product-links');
    let assocProductLinkSimple = $('.product-associated-product-btn-simple');
    let assocProductLinkConfig = $('.product-associated-product-btn-config');
    var simpleProductParams = {
        hingeSide: null,
        size: null,
        width: null,
        height: null,
    };
    let productStockStatus = [];

    $accessoriesResetButton.click(function() {
        resetSubProducts();
    });

    $accessoriesList.on('click', '.subProductItem__content-item', function() {
        const element = $(this),
            id = Number(element.attr('data-id')),
            index = isSubProductSelected(id);

        if (Number(element.attr('data-is-default')) === 1) {
            return false;
        }
        if (
            index < 0 &&
            Number(element.attr('data-quantity')) > 0
        ) {
            selectSubProduct(id);
        } else {
            unSelectSubProduct(id);
        }
        updatePrice();
    });

    function unSelectSubProduct(id) {
        const index = isSubProductSelected(id);

        configData.data[0].relationships.subproduct.data.splice(index, 1);

        $('#simpleConfiguratorAccessories')
            .find('[data-id=' + id + ']')
            .removeClass('--checked-item');

        updateStockStatus();
    }

    function selectSubProduct(id) {
        $('#simpleConfiguratorAccessories')
            .find('[data-id=' + id + ']')
            .addClass('--checked-item');

        configData.data[0].relationships.subproduct.data.push({
            'id': id,
            'type': 'subproduct',
        });

        updateStockStatus();
    }

    $widthSelect.on('change', function() {
        const mmWidth = Math.floor((this.value - 0.2) * 100);
        const mmHeight = Math.floor((configData.data[0].attributes.availableSizes[this.value][0] - 0.2) * 100);

        $heightSelect.html('');

        buildOptionsFromArray($heightSelect, configData.data[0].attributes.availableSizes[this.value]);

        configData.data[0].attributes.width = mmWidth;
        configData.data[0].attributes.height = mmHeight;

        updatePrice();
    });

    $heightSelect.on('change', function() {
        const mmHeight = Math.floor((this.value - 0.2) * 100);

        configData.data[0].attributes.height = mmHeight;

        updatePrice();
    });

    $quantity
        .on('input', function() {
            if ($(this).val()) {
                $(this).val(parseInt($(this).val()), 10);
            }
            if (parseInt($(this).val()) < 1 || $(this).val() === 'NaN') {
                $(this).val(1);
            }
            if ($(this).val() === '') {
                getPrice = false;
                return false;
            }
            var quantity = parseInt($(this).val());
            var perItemPrice = price - discount;
            var perItemNetPrice = netPrice - netDiscount;

            $total.text(formatPrice(perItemPrice * quantity));
            $totalWithoutTax.text(formatPrice(perItemNetPrice * quantity));
            $ordinary.text(formatPrice(price * quantity));
            $discount.text(formatPrice(price * quantity - perItemPrice * quantity));
            configData.data[0].attributes.quantity = quantity;
            updateSubProducts();
            validateSubProductsStock();
        })
        .on('blur', function quantityBlur() {
            if (!$(this).val()) {
                $(this).val(1);
                var perItemPrice = price - discount;
                var perItemNetPrice = netPrice - netDiscount;
                $total.text(formatPrice(perItemPrice * quantity));
                totalWithoutTax.text(formatPrice(perItemNetPrice * quantity));
                $ordinary.text(formatPrice(price * quantity));
                $discount.text(formatPrice(price * quantity - perItemPrice * quantity));
            }
            configData.data[0].attributes.quantity = $(this).val();
            updateSubProducts();
            validateSubProductsStock();
        });

    function hasSubProducts() {
        if (
            Array.isArray(configData.included.subproduct) &&
            configData.included.subproduct.length > 0
        ) {
            return true;
        }
        return false;
    }

    function populateAccessories() {
        if (!hasSubProducts()) {
            return false;
        }
        configData.included.subproduct.forEach(function(subproduct) {
            var wrapperElement = $accessoriesList.find('.subProductAdditionalItems .subProductItem__content');
            var priceElement = $('<span>');

            if (subproduct.attributes.isDefault) {
                wrapperElement = $accessoriesList.find('.subProductIncludedItems .subProductItem__content');
            }
            priceElement
                .append(
                    $('<span>')
                    .addClass('subProductItem__content-item-description-price')
                    .addClass('your-price')
                    .addClass(subproduct.attributes.isDefault || subproduct.attributes.price > 0 ? 'hidden' : '')
                    .text('+' + formatPrice(subproduct.attributes.price) + ' kr')
                )
                .append(
                    $('<span>')
                    .addClass('subProductItem__content-item-description-price')
                    .addClass('end-customer-price')
                    .addClass(subproduct.attributes.isDefault || subproduct.attributes.price > 0 ? 'hidden' : '')
                    .text('+' + formatPrice(subproduct.attributes.price) + ' kr')
                )
                .append(
                    $('<span>')
                    .addClass('subProductItem__content-item-description__quantity')
                    .text('Antal:')
                    .append(
                        $('<span>')
                        .addClass('subProductItem__content-item-description__quantity__value')
                        .text(0)
                    )
                );
            let accessoryBox = $('<div>')
                .addClass('subProductItem__content-item')
                .addClass(isSubProductSelected(subproduct.id) >= 0 ? '--checked-item' : '')
                .attr('data-id', subproduct.id)
                .attr('data-quantity', subproduct.attributes.quantity)
                .attr('data-is-default', Number(subproduct.attributes.isDefault))
                .append(
                    $('<div>')
                    .addClass('subProductItem__content-item-icon')
                    .html(
                        $('<div>')
                        .addClass('subProductItem__content-item-icon-fancybox')
                        .attr('href', subproduct.attributes.imgSrc)
                        .append(
                            $('<img>')
                            .addClass('subProductItem__content-item-icon-hover')
                            .attr('src', subproduct.attributes.fullImgSrc)
                        )
                        .append(
                            $('<img>')
                            .addClass('subProductItem__content-item-icon-img')
                            .attr('src', subproduct.attributes.imgSrc)
                        )
                    )
                )
                .append(
                    $('<div>')
                    .addClass('subProductItem__content-item-description')
                    .append(
                        $('<strong>')
                        .addClass('subProductItem__content-item-description-title')
                        .text(subproduct.attributes.name)
                        .attr('title', subproduct.attributes.name)
                    )
                    .append(priceElement)
                );

            wrapperElement.parent().removeClass('hidden');
            wrapperElement.append(accessoryBox);
        });
        $accessoriesList.removeClass('hidden');
    }

    function validateSubProductsStock() {
        const userQuantity = Number($quantity.val());
        var block = false;

        if (configData.data[0].relationships.subproduct.data.length === 0) {
            return;
        }

        configData.data[0].relationships.subproduct.data.forEach(function(subProduct) {
            const details = getIncluded('subproduct', subProduct.id);

            if (details.attributes.quantity < userQuantity) {
                block = true;
            }
        });
        if (block) {
            locks.stock = true;
            $buyButton.attr('disabled', 'disabled');
            $('.stock-status__info').show();
        } else {
            locks.stock = false;
            $buyButton.removeAttr('disabled');
            $('.stock-status__info').hide();
        }
    }

    function resetSubProducts() {
        configData.data[0].relationships.subproduct.data = [];

        $('.additionalAccessories')
            .find('.subProductItem__content-item')
            .removeClass('--checked-item');

        initialSubProductsSelected.forEach(function(item) {
            selectSubProduct(item.id);
        });
        updatePrice();
        validateSubProductsStock();
    }

    function saveProduct() {
        //block ability to save product before price calculation
        if (!getPrice) {
            false;
        }
        var payload = {
            data: [
                configData.data[0]
            ],
            productInfo: configData.productInfo,
            _csrfToken: $('meta[name="csrfToken"]').attr('content'),
        };
        if (editSource.value === 'offer') {
            payload.meta = {
                itemId: $('#itemId').val()
            };
            $.ajax({
                url: apiUrl + '/update-offer-position',
                type: 'POST',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                data: JSON.stringify(payload),
                success: function(response) {
                    const offerId = response.data[0].order_id;
                    if (response.meta.success) {
                        window.location.href = `/shop/offers/employee_summary/${offerId}`;
                    }
                }
            });
        } else {
            if (itemId.value != 0) {
                payload.meta = {
                    itemId: $('#itemId').val()
                };
            }
            $.ajax({
                url: apiUrl + '/add-to-cart',
                type: 'POST',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                data: JSON.stringify(payload),
                success: function(response) {
                    if (response.meta.success) {
                        updateCart(response.data);
                        $('.addedToBasketPopup').addClass('--visible');
                        getAddToCartPinterestEvent();
                        getAddToCartGTMEvent();
                    }
                }
            });
        }
    }

    function getIncluded(key, id) {
        var result = null;

        configData.included[key].forEach(function(element) {
            if (Number(element.id) === Number(id)) {
                result = element;
            }
        });
        return result;
    }

    function bindConfigAttribute($select, key) {
        if (configData.included[key] && configData.included[key].length > 0) {
            $select.empty();

            var defaultValue = configData.data[0].relationships[key].data.id;
            let filteredOptions = filterOptions(key, configData.included[key]);
            filteredOptions.forEach(function(element) {
                var selected = (Number(element.id) === Number(defaultValue)) ? '" selected="selected"' : '';
                if (selected) {
                    simpleProductParams[key] = element;
                }
                $select.append('<option value="' + element.id + selected + '">' + element.attributes.name + '</option>');
                updateSubProducts();
                validateSubProductsStock();
            }, this);
            $select.closest('.select-wrapper-config').removeClass('hidden');
            $select.unbind();
            $select.on('change', function() {
                const id = $(this).val();
                getPrice = false;
                configData.data[0].relationships[key].data.id = id;
                simpleProductParams[key] = getIncluded(key, id);
                updateSubProducts();
                resetSubProducts();
                updatePrice();
                updateStockStatus();
                refreshSizeAndHingeSideSelectors();
            });
        }
    }

    function refreshSizeAndHingeSideSelectors() {
        bindConfigAttribute($sizeSelect, 'size');
        bindConfigAttribute($hingeSelect, 'hingeSide');
    }

    function filterOptions(key, options) {
        if (key === 'size' && simpleProductParams.hingeSide) {
            return options.filter(function(option) {
                return option.attributes.availableHingeSides.includes(simpleProductParams.hingeSide.id);
            });
        }

        if (key === 'hingeSide' && simpleProductParams.size) {
            return options.filter(function(option) {
                return simpleProductParams.size.attributes.availableHingeSides.includes(option.id);
            });
        }

        return options;
    }

    function updateSubProducts() {
        configData.included.subproduct.forEach(function(subProduct) {
            var matchingSize = null;
            var matchingHingeSide = null;

            if (Object.keys(subProduct.included.size).length > 0) {
                matchingSize = subProduct.included.size.find(function(size) {
                    return simpleProductParams.size &&
                        size.attributes.articleNumberSymbol === simpleProductParams.size.attributes.articleNumberSymbol;
                });
                if (
                    typeof matchingSize !== 'undefined' &&
                    Object.keys(matchingSize).length > 0
                ) {
                    updateSubProductBox(subProduct.id, matchingSize.attributes);
                } else {
                    updateSubProductBox(subProduct.id, {
                        quantity: 0,
                        price: 0,
                    });
                }
            } else if (Object.keys(subProduct.included.hingeSide).length > 0) {
                matchingHingeSide = subProduct.included.hingeSide.find(function(hingeSide) {
                    return simpleProductParams.hingeSide &&
                        hingeSide.attributes.articleNumberSymbol === simpleProductParams.hingeSide.attributes.articleNumberSymbol;
                });
                if (
                    typeof matchingHingeSide !== 'undefined' &&
                    Object.keys(matchingHingeSide).length > 0
                ) {
                    updateSubProductBox(subProduct.id, matchingHingeSide.attributes);
                } else {
                    updateSubProductBox(subProduct.id, {
                        quantity: 0,
                        price: 0,
                    });
                }
            } else {
                updateSubProductBox(subProduct.id, subProduct.attributes);
            }
        });
    }

    function updateSubProductBox(id, details) {
        const userQuantity = Number($quantity.val());
        const subProductDetailsIndex = configData.included.subproduct.findIndex(x => x.id === id);
        const element = $('#simpleConfiguratorAccessories')
            .find('[data-id=' + id + ']');

        if (isSubProductIncluded(id)) {
            if (details.quantity === 0 || details.quantity < userQuantity) {
                element.addClass('--unavailable-item');
            } else {
                element.removeClass('--unavailable-item');
            }
        }
        element
            .attr('data-quantity', details.quantity)
            .find('.subProductItem__content-item-description-price')
            .removeClass('hidden')
            .addClass(details.price === 0 ? 'hidden' : '')
            .text('+' + formatPrice((isB2bModeEnabled() ? details.netPrice : details.price) ?? 0) + ' kr');

        element
            .attr('data-quantity', details.quantity)
            .find('.subProductItem__content-item-description__quantity__value')
            .text(details.quantity);

        element
            .find('.subProductItem__content-item-description__quantity')
            .removeClass('red')
            .removeClass('green')
            .addClass(details.quantity > 0 ? 'green' : 'red')

        configData.included.subproduct[subProductDetailsIndex].attributes.quantity = details.quantity;
    }

    function isSubProductSelected(id) {
        return configData.data[0].relationships.subproduct.data.findIndex(x => x.id === id);
    }

    function isSubProductIncluded(id) {
        return initialSubProductsSelected.findIndex(x => x.id === id) == -1 ? false : true;
    }

    function bindCustomBoxes() {
        if (configData.included.customBoxes && configData.included.customBoxes.length > 0) {
            configData.included.customBoxes.forEach(function(customBox) {
                bindCustomBox(customBox);
            });
        }
    }

    function bindCustomBox(customBox) {
        var title = customBox.attributes.name;
        var input = '';
        var options = '';
        var customBoxesData = configData.data[0].relationships.customBoxes;
        var currentBox = customBoxesData.find(function(box) {
            return box.data.id === customBox.id;
        });
        if (customBox.attributes.type === 'number') {
            input = '<input type="number" class="option-input" value="' + currentBox.data.value + '">';
        } else {
            var defaultValue = currentBox.data.value.id;
            options = customBox.attributes.values.map(function(option) {
                var selected = (option.id === defaultValue) ? ' selected="selected"' : '';
                return '<option value="' + option.id + '"' + selected + '>' + option.name + '</option>';
            });
            input = '<select class="option-select">' + options.join('') + '</select><input style="display: none;" type="number" class="option-input">';
        }
        $selectParameters.append(
            '<div class="select-wrapper-config"><h5 class="select-header" id="custom-select-header">' + title + '</h5>' + input + '</div>'
        );

        $selectParameters.find(':last-child input').on('blur', function() {
            var value = parseInt($(this).val());

            if (customBox.attributes.type === 'number' && !isNaN(value)) {
                var error = false;
                if (value < customBox.attributes.minimal_value) {
                    value = customBox.attributes.minimal_value;
                    error = true;
                }
                if (value > customBox.attributes.maximal_value) {
                    value = customBox.attributes.maximal_value;
                    error = true;
                }
                currentBox.data.value = value;
                $(this).val(value);
                $(this).toggleClass('error', error);
                if (error) {
                    $configurator.find('.error-message').show();
                } else {
                    $configurator.find('.error-message').hide();
                }
                updatePrice();
            } else if (customBox.attributes.type === 'select') {
                currentBox.data.additionalValue = value;
            }
        });
        $selectParameters.find(':last-child select').on('change', function() {
            if (customBox.attributes.type !== 'select') return;
            var value = $(this).val();
            var boxValue = customBox.attributes.values.find(function(boxValue) {
                return boxValue.id === Number(value);
            });
            if (boxValue) {
                currentBox.data.value = boxValue;
            }
            if (boxValue.show_numeric_field) {
                $(this).next().show();
            } else {
                $(this).next().hide();
                delete currentBox.data.additionalValue;
            }
        }).change();
    }

    function getConfig() {
        $.ajax({
            url: apiUrl + '/get-product/' + product + '/' + config + ((edit) ? '/' + edit : ''),
            type: 'GET',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            success: function(response) {
                configData = response;
                initialSubProductsSelected = $.extend(true, [], configData.data[0].relationships.subproduct.data);

                var widths = [];
                var heights = [];
                const availableSizes = configData.data[0].attributes.availableSizes;

                $quantity.val(configData.data[0].attributes.quantity);

                populateAccessories();
                bindConfigAttribute($sizeSelect, 'size');
                bindConfigAttribute($hingeSelect, 'hingeSide');
                bindCustomBoxes();
                updatePrice();
                updateStockStatus(configData);
                showAssociatedProductLink();
                setSizeBasedOnAssociation();
                getProductsFromGroup();
                setPriceSwitchState();

                if (typeof availableSizes !== 'undefined' && Object.keys(availableSizes).length > 0) {
                    for (var width in availableSizes) {
                        widths.push(width);

                        availableSizes[widths[0]].forEach(function(height) {
                            heights.push(height);
                        });
                    }
                    $widthSelect.closest('.select-wrapper-config').removeClass('hidden');
                    $heightSelect.closest('.select-wrapper-config').removeClass('hidden');
                    $sizeSelect.closest('.select-wrapper-config').addClass('hidden');

                    buildOptionsFromArray($widthSelect, widths);
                    buildOptionsFromArray($heightSelect, heights);
                }
                // Preselect size and hinge if needed
                const urlParams = new URLSearchParams(window.location.search);
                const urlSize = urlParams.get('storlek');
                const urlHinge = urlParams.get('hangning');

                if (urlSize) {
                    configData.included['size'].forEach(function (size) {
                        if (size.attributes.articleNumberSymbol === urlSize) {
                            $sizeSelect
                                .val(size.id)
                                .change();
                        }
                    });
                }
                if (urlHinge) {
                    configData.included['hingeSide'].forEach(function (hingeSide) {
                        if (hingeSide.attributes.articleNumberSymbol === urlHinge) {
                            $hingeSelect
                                .val(hingeSide.id)
                                .change();
                        }
                    });
                }
            }
        });
    }

    function updateStockStatus() {
        if (configData.data[0].attributes.isStockItem) {
            $('.stock-status__spinner').show();
            $('.stock-status__value').text('');

            $buyButton.attr('disabled', 'disabled');

            const cacheKey = generateStockProductCacheKey(configData);

            if (productStockStatus && productStockStatus[cacheKey]) {
                configData.data[0].attributes.articleNumber = productStockStatus[cacheKey]['article_number'];
                setStockStatus(Number(productStockStatus[cacheKey]['quantity']));
            } else {
                $.ajax({
                    url: apiUrl + '/getProductNumberAndStockStatus',
                    type: 'POST',
                    dataType: 'json',
                    data: JSON.stringify(configData),
                    contentType: 'application/json; charset=utf-8',
                    success: function(response) {
                        configData.data[0].attributes.articleNumber = response.data[0].article_number;

                        productStockStatus[cacheKey] = [];
                        productStockStatus[cacheKey]['quantity'] = response.data[0].quantity;
                        productStockStatus[cacheKey]['article_number'] = response.data[0].article_number;

                        setStockStatus(Number(response.data[0].quantity));
                    }
                });
            }
        }
    }

    function generateStockProductCacheKey(configData) {
        var cacheKey = 0;

        if (
            typeof configData.data[0].relationships.size !== 'undefined' &&
            configData.data[0].relationships.size !== null
        ) {
            cacheKey = configData.data[0].relationships.size.data.id;
        }
        if (
            typeof configData.data[0].relationships.hingeSide !== 'undefined' &&
            configData.data[0].relationships.hingeSide !== null
        ) {
            cacheKey += '-' + configData.data[0].relationships.hingeSide.data.id;
        }
        return cacheKey;
    }

    function setStockStatus(quantity) {
        let userQuantity = Number($quantity.val());

        $('.stock-status__value').text(quantity);
        $('.stock-status__spinner').hide();

        if (quantity === 0) {
            $('.stock-status__info').show();
            $quantity.attr('max', 1);
            $quantity.val(1);
            locks.stock = true;
            $buyButton.attr('disabled', 'disabled');
            $quantity.attr('disabled', 'disabled');
        } else if (quantity < userQuantity) {
            $('.stock-status__info').hide();

            $quantity.attr('max', quantity);
            $quantity.val(quantity);
            $quantity.attr('disabled', 'disabled');

            locks.stock = false;

            validateSubProductsStock();
        } else {
            $quantity.attr('max', quantity);
            getStockStatus = true;
            locks.stock = false;
            $buyButton.removeAttr('disabled');
            $quantity.removeAttr('disabled');
            $('.stock-status__info').hide();
            validateSubProductsStock();
        }
    }

    function formatPrice(value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    function updatePrice() {
        configData._csrfToken = $('meta[name="csrfToken"]').attr('content');
        $.ajax({
            url: apiUrl + '/calculate-product-price',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify(configData),
            success: function(response) {
                if (response.meta.success) {
                    subProductsPrice = 0;
                    subProductsNetPrice = 0;
                    subProductsDiscount = 0;

                    if (configData.included.priceM) {
                        $priceUnit.text('kr/lpm')
                    } else {
                        $priceUnit.text('kr')
                    }
                    if (response.data[0].subProducts.length > 0) {
                        response.data[0].subProducts.forEach(function(subproduct) {
                            subProductsPrice += subproduct.price * $quantity.val();
                            subProductsNetPrice += subproduct.netPrice * $quantity.val();
                            subProductsDiscount += subproduct.discountValue * $quantity.val();
                        });
                    }
                    price = subProductsPrice + response.data[0].price;
                    regularCustomerPrice = subProductsPrice + response.data[0].regularCustomerPrice;
                    netPrice = subProductsNetPrice + response.data[0].netPrice;
                    discount = response.data[0].discount;
                    discountValueForRegularCustomer = response.data[0].discountValueForRegularCustomer;
                    netDiscount = response.data[0].netDiscount;
                    discountValue = response.data[0].lineDiscountValue;

                    $item.text((price - discount));
                    $total.text(formatPrice((price - discount) * $quantity.val()));
                    $totalWithoutTax.text(formatPrice((netPrice - netDiscount) * $quantity.val()));
                    $ordinary.text(formatPrice(price));
                    $ordinaryItem = price;
                    $regularDiscount.text(formatPrice(discountValueForRegularCustomer * $quantity.val()));
                    $regularOrdinary.text(formatPrice((regularCustomerPrice + discountValueForRegularCustomer) * $quantity.val()));

                    if (discount <= 0) {
                        $discount.parents('.ordinary-price').hide();
                        $('[data-price="ordinary"]').parents('.ordinary-price').hide();
                        $('[data-price="regular-ordinary"]').parents('.ordinary-price').hide();
                        $('[data-price="regular-discount"]').parents('.ordinary-price').hide();
                    }
                    if (regularCustomerPrice !== 0) {
                        $totalForRegularCustomer.text(formatPrice((regularCustomerPrice - discountValueForRegularCustomer) * $quantity.val()));
                    } else {
                        $('.regular-customer-price').hide();
                    }
                    finalDiscount = subProductsDiscount + discount;

                    if (finalDiscount > 0) {
                        $discount.text(formatPrice(finalDiscount));
                        $discountValue.text(discountValue);
                        $('.discount-info').show();
                    } else {
                        $('.discount-info').hide();
                    }
                    getPrice = true;

                    if (!locks.stock && !locks.subProducts) {
                        $buyButton.removeAttr('disabled');
                    }
                }
            }
        });
    }

    $quantity.on('input', function() {
        updatePrice();
        updateStockStatus();
    });

    $configurator.find('[data-submit]').on('click', function(event) { // FIXME send proper informations
        event.preventDefault();
        saveProduct();
    });
    getConfig();

    $('.addedToBasketPopup__continueShopping').on('click', function() {
        $('.addedToBasketPopup').removeClass('--visible');
    })

    function showAssociatedProductLink() {
        if (configData.productInfo.associatedProductUrl) {
            assocProductLinkConfig.attr('href', configData.productInfo.associatedProductUrl);
            assocProductSwitch.css('display', 'grid');
        }
    }

    function setSizeBasedOnAssociation() {
        let sizeInMillimeters = localStorage.getItem('associatedConfigurationSize-' + config);
        if (sizeInMillimeters) {
            let size = configData.included.size.find(x => x.attributes.sizeInMillimeters == sizeInMillimeters);
            if (size && size.id) {
                $sizeSelect.val(size.id);
            }
            localStorage.removeItem('associatedConfigurationSize-' + config);
        }
    }

    function setAssociatedProductConfiguration() {
        if (configData.productInfo.associatedConfigurationId != null && configData.productInfo.associatedProductColorId != null) {
            localStorage.setItem('associatedConfigurationColor-' + configData.productInfo.associatedConfigurationId, configData.productInfo.associatedProductColorId);
        }

        let sizeSelectorValue = $('.size').val();
        let size = configData.included.size.find(x => x.id == +sizeSelectorValue).attributes.sizeInMillimeters;
        if (configData.productInfo.associatedConfigurationId != null && size != null) {
            localStorage.setItem('associatedConfigurationSize-' + configData.productInfo.associatedConfigurationId, size);
        }
    }

    $('.product-associated-product-btn-simple, .product-associated-product-btn-config').click(function() {
        setAssociatedProductConfiguration();
    });

    function buildOptionsFromArray(select, array) {
        for (var key in array) {
            $(select).append(
                $('<option>')
                .attr('value', array[key])
                .text(array[key])
            );
        }
        $(select).find('option:eq(0)').prop('selected', true);
    }

    function getAddToCartPinterestEvent() {
        let productPrice = price - discount;

        pintrk('track', 'AddToCart', {
            value: productPrice,
            order_quantity: $quantity.val(),
            currency: 'SEK'
        });
    }

    function getAddToCartGTMEvent() {
        let productPrice = price - discount;

        googleTagManagerService.pushAddToCartDataLayer(
            productPrice,
            configData.data[0].attributes.articleNumber,
            configData.productInfo.configurationName,
            configData.productInfo.productCategory,
            $quantity.val()
        );
    }

    function getProductsFromGroup() {
        let productsFromGroupContainer = $('.productsFromGroup__container');
        configData.productInfo.productsFromGroup.forEach(function(product) {
            let link = $('<a></a>').attr('href', product.url);
            link.addClass('productsFromGroup__product');
            if (product.id === configData.data[0].relationships.configuration.data.id) {
                link.addClass('--checked');
            }
            let img = $('<img>').attr('src', product.img);
            link.append(img);

            let productName = $('<span>');
            productName.text(product.name);
            link.append(productName);

            productsFromGroupContainer.append(link);
        });
    }
});

(function() {
    $(".configurator__image-gallery").lightGallery({
        download: false,
        autoplayFirstVideo: false,
        thumbnail: true,
        animateThumb: false,
        showThumbByDefault: true,
        currentPagerPosition: 'right',
        selector: '.configurator__gallery-image'
    });

    var swiper = new Swiper('.configurator__images-thumbnails', {
        slidesPerView: 8,
        spaceBetween: 10,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
})();
